module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_3016.b2129613.png";